import React, { useState, useEffect, useContext } from 'react'
import Stack from '@mui/material/Stack';
import { StoredContext } from './App.js';
import UserInput from './UserInput'
import Results from './Results';
import { hourlyVx } from './js/constants';

export default function ProductInterface(props) { 
  const { product, ProductOptions, processProduct } = props;
  const [ result, setResult ] = useState("");
  const [ userParams, setUserParams ] = useState();
  const [ processRequest, setProcessRequest ] = useState(false);
  const { storedParams, setStoredParams } = useContext(StoredContext);

  const startProcessRequest = () => {
    setResult("Processing request...");
    setProcessRequest(false);
    processProduct(userParams, setResult, hourlyVx, setUserParams);
    const updatedStore = {};
    Object.keys(storedParams).map((p) => {
      if (userParams[p]) {
        updatedStore[p] = userParams[p];
      }
    });
    setStoredParams({ ...storedParams, ...updatedStore });
  }

  useEffect(() => {
    if (processRequest) {
      startProcessRequest();
    }
  }, [processRequest]);

  useEffect(() => {
    if (product !== 'gridmap') {
      setResult("");
    }
  }, [userParams]);

  return (
    <>
      <Stack direction="column" spacing={1} width="100%">
        <UserInput
          product = {product}
          userParams = {userParams}
          setUserParams = {setUserParams}
          setProcessRequest = {setProcessRequest}
          ProductOptions = {ProductOptions}
        />
        <Results
          result = {result}
        />
      </Stack>
    </>
  )
} 